import type { JSX } from 'react';
import { EpisodeCategory } from '@common/enums';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { BariatricsSidebar } from './bariatrics/BariatricsSidebar';

const patientEpisodeCategorySidebarComponents: {
    [key in EpisodeCategory]?: () => JSX.Element | null;
} = {
    [EpisodeCategory.bariatrics]: BariatricsSidebar,
};

export function PatientEpisodeCategorySidebar(): JSX.Element | null {
    const { episodeCategory } = usePatientEpisodeCategoryContext();
    const Component = patientEpisodeCategorySidebarComponents[episodeCategory];

    if (!Component) {
        return null;
    }

    return <Component />;
}
